import React, {Component} from 'react';
import Radium from 'radium';
import {StyleRoot} from 'radium';
import color from 'color';
import InputBar from '../components/InputBar';
import MessageList from '../components/MessageList';
import LoadingElement from '../components/LoadingElement';
import ContainerWrapper from './ContainerWrapper';
import Lightbox from './Lightbox';

class Container extends Component {

	constructor(props) {
		super(props);
		this.state = { 
			inputHeight: '45',
			loaderHidden: true,
			lightboxMessage: null
		}
	}

	componentDidMount() {
		setTimeout(() => {
			// Show loader if page still hasn't loaded after 500ms
			this.setState({loaderHidden: false});
		}, 500);
	}

	setInputHeight(height) {
		this.setState({inputHeight: height});
	}

	// Focus (and blur) input element triggered at container level because must be used by InputBar and MessageList child components
	// TODO: Pass message element from InputBar -> InputBar should be self-contained
	focusInputElement() {
		document.getElementById('message-input') && document.getElementById('message-input').focus();
	}

	blurInputElement() {
		document.getElementById('message-input') && document.getElementById('message-input').blur();
	}

	// Blur or focus from window message events
	onMessageEvent(event) {
		const payload = event.data;

		if (typeof payload === 'string') {
			switch (payload) {
				case 'focus':
					this.focusInputElement();
					break;
				case 'blur':
					this.blurInputElement();
					break;
				default:
					return;
			}
		}
	}

	setLightbox(message) {
		this.setState({
			lightboxMessage: message
		});
	}

	render() {
		let container;

		if (this.props.pageState.get("loading") && !this.state.loaderHidden) {
			container = 
				<div className="loading-container" style={[styles.loadingContainer]}>
		  			<LoadingElement className="loading-container__element" showElement={true} />
	  			</div >
		} else if (!this.props.pageState.get("chatEnabled")) {
			container = 
				<div className="error-container" style={[styles.errorContainer]}>
						<img 
							src="https://static.ada.support/warning-yellow.svg"
							alt="" 
						/>
						<p>This bot has been disabled. If you are the owner, you can enable Web Chat in the Platforms section of your Settings view.</p>
				</div>
		} else if (this.props.pageState.get("hasErrors")) {
			container = 
				<div className="error-container" style={[styles.errorContainer]}>
						<img 
							src="https://static.ada.support/warning-yellow.svg"
							alt="" 
						/>
						<p>{this.props.pageState.get("errorMessage")}</p>
				</div>
		} else {
			container =
		  		<div id="message-container" style={[styles.messageContainer]}>
		  			{this.props.client.showLogo &&
			  			<div className="top-bar">
				  			<a href="https://ada.support/" target="_blank" style={[styles.messageContainer.logo]}>
				  				<img src="https://static.ada.support/icon/Knockout%20Black.svg" style={[styles.messageContainer.logo.image]} />
			  				</a>
		  				</div>
	  				}
				  	<MessageList 
				  		client={this.props.client} 
				  		messages={this.props.messages}
				  		suggestedResponses= {this.props.suggestedResponses}
				  		onHandlePostBack={this.props.addPostBack}
				    	inputHeight={this.state.inputHeight}
				    	messageLoader={this.props.messageLoader}
				    	pageState={this.props.pageState}
				    	focusInputElement={this.focusInputElement}
				    	setLightbox={(message) => this.setLightbox(message)}
				    	retryMessage={(message) => this.props.retryMessage(message)}
			  		/>
				    <InputBar 
				    	client={this.props.client} 
				    	currentMessage={this.props.currentMessage}
				    	updateMessage={this.props.updateMessage}
				    	onSubmit={this.props.addMessage}
				    	setInputHeight={this.setInputHeight.bind(this)}
				    	pageState={this.props.pageState}
				    	focusInputElement={this.focusInputElement}
				    />
    				{!!this.state.lightboxMessage && 
						<Lightbox 
							message={this.state.lightboxMessage}
							closeLightbox={() => this.setLightbox(null)}
						/>
					}
		  		</div>
		}
		// Styleroot is needed by Radium
		return (
			<ContainerWrapper onMessageEvent={this.onMessageEvent.bind(this)}>
				<StyleRoot style={[styles.styleroot]}>
					{container}
			    </StyleRoot>
		    </ContainerWrapper>
	    );
	}
}

const styles = {
	styleroot: {
		fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
		fontSize: '18px',
		fontWeight: '400'
	},

	loadingContainer: {
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translateY(-50%)',
		transform: 'translateX(-50%)'
	},

	errorContainer: {
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translate3d(-50%, -50%, 0)',
	    textAlign: 'center'
	},

    messageContainer: {
		position: 'fixed',
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
	    backgroundColor: 'white',

	    logo: {
	    	position: 'fixed',
	    	top: '12px',
	    	left: '12px',
	    	height: '24px',
	    	width: '24px',
	    	zIndex: '1',
	    	borderRadius: '5px',
	    	overflow: 'hidden',
	    	backgroundColor: 'rgba(255, 255, 255, 0.3)',

	    	image: {
	    		height: '100%',
	    		width: '100%',
	    		opacity: '0.14',
	    		transition: 'opacity 0.2s ease',

				':hover': {
					opacity: '0.24'
				}
	    	}
	    }
    }
};

export default Radium(Container);


// WEBPACK FOOTER //
// ./src/components/Container.js